<header *ngIf="show" class="loader navbar-fixed-top"></header>